import React from 'react'
import styled from 'styled-components'

const Container = styled.div`
  max-width: 800px;
  margin: 0 auto;
  padding: 2rem;
  color: var(--color-text);
`

const Title = styled.h1`
  font-size: 2.5rem;
  color: var(--color-primary);
  margin-bottom: 2rem;
`

const Section = styled.section`
  margin-bottom: 2rem;
`

const SectionTitle = styled.h2`
  font-size: 1.5rem;
  color: var(--color-text);
  margin-bottom: 1rem;
`

const Text = styled.p`
  font-size: 1rem;
  line-height: 1.6;
  margin-bottom: 1rem;
  color: var(--color-text-secondary);
`

const List = styled.ul`
  margin-left: 1.5rem;
  margin-bottom: 1rem;

  li {
    color: var(--color-text-secondary);
    margin-bottom: 0.5rem;
    line-height: 1.6;
  }
`

export default function Privacy() {
  return (
    <Container>
      <Title>Privacy Policy</Title>

      <Section>
        <SectionTitle>Introduction</SectionTitle>
        <Text>
          At OmniBrain, we take your privacy seriously. This Privacy Policy explains how we collect,
          use, disclose, and safeguard your information when you use our platform.
        </Text>
      </Section>

      <Section>
        <SectionTitle>Information We Collect</SectionTitle>
        <Text>We collect information that you provide directly to us, including:</Text>
        <List>
          <li>Wallet addresses and blockchain transaction data</li>
          <li>Project requirements and specifications</li>
          <li>Communication preferences</li>
          <li>Usage data and interaction with our platform</li>
        </List>
      </Section>

      <Section>
        <SectionTitle>How We Use Your Information</SectionTitle>
        <Text>We use the collected information for various purposes:</Text>
        <List>
          <li>To provide and maintain our platform services</li>
          <li>To process your project requests and deploy AI agents</li>
          <li>To communicate with you about your projects and our services</li>
          <li>To improve our platform and user experience</li>
          <li>To ensure secure and authenticated access to our services</li>
        </List>
      </Section>

      <Section>
        <SectionTitle>Data Security</SectionTitle>
        <Text>
          We implement appropriate technical and organizational security measures to protect your
          information. However, please note that no method of transmission over the internet or electronic
          storage is 100% secure.
        </Text>
      </Section>

      <Section>
        <SectionTitle>Blockchain Data</SectionTitle>
        <Text>
          Please be aware that any information you submit to the blockchain will be publicly available.
          The blockchain is a distributed ledger that maintains a permanent, immutable record of all
          transactions. This means that any project data or wallet addresses you submit will be publicly
          accessible.
        </Text>
      </Section>

      <Section>
        <SectionTitle>Third-Party Services</SectionTitle>
        <Text>
          Our platform integrates with various third-party services, including blockchain networks and
          development tools. These services may collect information about you. We recommend reviewing
          their respective privacy policies.
        </Text>
      </Section>

      <Section>
        <SectionTitle>Your Rights</SectionTitle>
        <Text>You have the right to:</Text>
        <List>
          <li>Access your personal information</li>
          <li>Correct inaccurate data</li>
          <li>Request deletion of your data (where applicable)</li>
          <li>Object to our processing of your information</li>
          <li>Withdraw consent at any time</li>
        </List>
      </Section>

      <Section>
        <SectionTitle>Updates to This Policy</SectionTitle>
        <Text>
          We may update this Privacy Policy from time to time. We will notify you of any changes by
          posting the new Privacy Policy on this page and updating the "Last Updated" date.
        </Text>
      </Section>

      <Section>
        <SectionTitle>Contact Us</SectionTitle>
        <Text>
          If you have any questions about this Privacy Policy, please contact us through our support
          channels or submit an inquiry through our platform.
        </Text>
      </Section>

      <Text style={{ marginTop: '2rem', fontStyle: 'italic' }}>
        Last Updated: January 21, 2024
      </Text>
    </Container>
  )
}
